import get from './{folderId}';
export default { get };
